import { Component, OnInit , OnDestroy,  ElementRef, ViewChild, Renderer2, QueryList, ViewChildren} from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { EchexpaymentService } from '../echexpayment.service';
import { LocalstorageService } from '../localstorage.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
@Component({
  selector: 'echxpayment-plan',
  templateUrl: './planform.component.html',
  styleUrls: ['./plan.component.css']
})
export class CreateplanComponent implements OnInit, OnDestroy {
	@ViewChild('f') myForm : NgForm;
	createplan: boolean = true;
	editplan: boolean = false;
    public plan: any = {interval:'', status: ''};
    public token: string;
    public planlist: string;
    public data: any;
    public filterQuery = "";
    public rowsOnPage = 1;
    public sortBy = "plan_name";
		public sortOrder = "asc";
		public check_no_of_users:boolean = false;
	  public check_no_of_cheque:boolean = false;


    public addChecks = false
    public addUsers = false;
    public custominterval = false;

    busy: Subscription;

   //data validation
    public val_plan_name : boolean = false;
    public val_plan_id : boolean = false;
    public val_no_of_cheque : boolean = false;
    public val_no_of_user : boolean = false;
    public val_amount : boolean = false;
    public val_status : boolean = false;
    public val_interval : boolean = false;
    public val_trial_period : boolean = false;
    public val_settings : boolean = false;
    public val_appear_in : boolean = false;
	public enter_cheque : string;
	public send_cheque : string;
	public create_secure_url_link : string;
	public create_bank_auth_url_link : string;

	public showWarning: boolean = false;
	public show_nocheck: boolean = false;
	public show_nouser: boolean = false;
	public zerovalidate: boolean = false;


	public link_options = [
		{ name:'Enter Check', value: 'enter_cheque', selected: false },
		{ name:'Send Check', value: 'send_cheque', selected: false },
		{ name:'Create Secure Url Link', value: 'create_secure_url_link', selected: false },
		{ name:'Create Bank Auth Url Link', value: 'create_bank_auth_url_link', selected: false }
	];
	NamecharacterLimitReached: { [key: string]: boolean } = {};

	constructor(private router: Router, private Location : Location, private renderer: Renderer2, private toastr: ToastrService, private elementRef: ElementRef, private echexpaymentService :EchexpaymentService, private localStorageService: LocalstorageService) { 
	this.router = router;
	var currentUser = this.localStorageService.getData("currentUserToken");
	this.token =  currentUser.data.user_token;
	}

	ngOnInit() {
	}
	
	ngOnDestroy() {
		this.toastr.clear();
	  }

	ngAfterViewInit() {
		this.renderer.selectRootElement('#Initial_focus').focus();
	}


	
	// hide error message when input box get focus
    eventHandler(){
      this.val_plan_name = false;
      this.val_plan_id = false;
      this.val_no_of_cheque = false;
      this.val_no_of_user = false;
      this.val_amount = false;
      this.val_status = false;
      this.val_interval = false;
      this.val_trial_period = false;
      this.val_settings = false;
      this.val_appear_in = false;
	  this.enter_cheque = 'no';
    }
	// add number checks fuctions
	addNumberOfChecks(value: boolean){
		if(value == true){
			this.addChecks = true;
		}
		if(value == false){
			this.addChecks = false;
		}
	}
	// add number of user function
	addNumberOfUser(value: boolean){
		if(value == true){
		 this.addUsers = true;
		}
		if(value == false){
		 this.addUsers = false;
		}
	}
	@ViewChild('submitButton') submitButton: ElementRef;

	@ViewChild('SelectOption') selectOption: ElementRef;

	moveNext(nextInput: HTMLInputElement, checkbox: number = 0) {
		if(checkbox === 1){
			this.focusFirstCheckbox();
		} else if(checkbox === 5){
			const formValue = this.myForm.value;
			 if(formValue.check_no_of_users === true){
				this.renderer.selectRootElement('#plan8').focus();
			} else{
				this.renderer.selectRootElement('#FocusStatus').focus();
			}
		} else if(checkbox === 2){
			if (this.submitButton && this.submitButton.nativeElement) {
				this.submitButton.nativeElement.focus();
				this.submitButton.nativeElement.click();
			}
		} else{
			nextInput && nextInput.focus();
		}
	}

	@ViewChildren('Focus_Entercheck') checkboxRefs: QueryList<ElementRef>;
	@ViewChild('no_cheque') noChequeInput: ElementRef;
	focusFirstCheckbox() {
	  const firstCheckbox = this.checkboxRefs.first;
	  if (firstCheckbox && firstCheckbox.nativeElement) {
		firstCheckbox.nativeElement.focus();
	  } else if (this.noChequeInput && this.noChequeInput.nativeElement) {
		this.noChequeInput.nativeElement.focus();
	  }
	}

	@ViewChild('selectBox') selectBox: ElementRef;
	focusNextCheckbox(index: number) {
		const formValue = this.myForm.value;
		const nextIndex = index + 1;
		if (nextIndex < this.checkboxRefs.length) {
		  const nextCheckbox = this.checkboxRefs.toArray()[nextIndex];
		  if (nextCheckbox && nextCheckbox.nativeElement) {
			nextCheckbox.nativeElement.focus();
		  }
		} else {
			if(formValue.check_no_of_cheque === true){
				this.renderer.selectRootElement('#plan7').focus();
			} else if(formValue.check_no_of_users === true){
				this.renderer.selectRootElement('#plan8').focus();
			} else {
				if (this.selectBox && this.selectBox.nativeElement) {
					this.selectBox.nativeElement.focus();
				}
			}
		}
	  }
	// Focus error field
	focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	}

	validateFields(event: any) {
		if(event === '0'){
			this.show_nocheck = true
		} else{
			this.show_nocheck = false
		}
	  }
	  validate_userFields(event:any){
		if(event === '0'){
			this.show_nouser = true
		} else{
			this.show_nouser = false
		}
	  }
	  
	// Create Plan

	createPlan(data: { valid: any; value: any; }) {
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.value.no_of_cheque === '0' && data.value.no_of_user === '0'){
			 this.zerovalidate = true;
		} else{
			this.zerovalidate = false;
			if(data.valid){
				let model: any = data.value;
				
				if(typeof model.plan_name === 'undefined'  || model.plan_name === null || model.plan_name === ''){
				this.val_plan_name = true;
				return false;
				}

				if(typeof model.plan_id === 'undefined'  || model.plan_id === null || model.plan_id === ''){
				this.val_plan_id = true;
				return false;
				}

				if(typeof model.amount === 'undefined'  || model.amount === null || model.amount === ''){
				this.val_amount = true;
				return false;
				}

				if(typeof model.appear_in === 'undefined'  || model.appear_in === null || model.appear_in === ''){
				this.val_appear_in = true;
				return false;
				}

				if(typeof model.interval === 'undefined'  || model.interval === null || model.interval === ''){
				this.val_interval = true;
				return false;
				}

				if(typeof model.trial_period_days === 'undefined'  || model.trial_period_days === null || model.trial_period_days === ''){
				this.val_trial_period = true;
				return false;
				}

				if(this.addChecks === true){

				if(typeof model.no_of_cheque === 'undefined'  || model.no_of_cheque === null || model.no_of_cheque === ''){
					this.val_no_of_cheque = true;
					return false;
				}
				}

				if(this.addUsers === true){

				if(typeof model.no_of_user === 'undefined'  || model.no_of_user === null || model.no_of_user === ''){
					this.val_no_of_user = true;
					return false;
				}
				}
				for (let option of this.link_options) {
					let optionVal = option.value;
					
					if (option.selected && optionVal == 'enter_cheque') {
						model.enter_cheque = 'yes';
					}
					if (!option.selected && optionVal == 'enter_cheque') {
						model.enter_cheque = 'no';
					}
					if (option.selected && optionVal == 'send_cheque') {
						model.send_cheque = 'yes';
					}
					if (!option.selected && optionVal == 'send_cheque'){
						model.send_cheque = 'no';
					}
					if (option.selected && optionVal == 'create_secure_url_link') {
						model.create_secure_url_link = 'yes';
					}
					if (!option.selected && optionVal == 'create_secure_url_link'){
						model.create_secure_url_link = 'no';
					}
					if (option.selected && optionVal == 'create_bank_auth_url_link') {
						model.create_bank_auth_url_link = 'yes';
					}
					if (!option.selected && optionVal == 'create_bank_auth_url_link'){
						model.create_bank_auth_url_link = 'no';
					}
				}
				if(this.addUsers === true){
					if(typeof model.no_of_user === 'undefined'  || model.no_of_user === null || model.no_of_user === ''){
					this.val_no_of_user = true;
					return false;
					}
				}

				if(typeof model.status === 'undefined'  || model.status === null || model.status === ''){
				this.val_status = true;
				return false;
				}

				model.token = this.token
				let responseData = <any>{};
				this.busy = this.echexpaymentService.createPlan(model).subscribe(
					response => {
					responseData = response;
					this.toastr.success(responseData.message, 'Success!');
					this.router.navigate(['/plan']);
				},
				error => {
						responseData = error;
						this.toastr.error(responseData.error.message, 'Failed!');
				}
				);
			}
	  }
	}

	NameCharacterLimit(event: any, fieldName: string) {
		const maxTextLength = 25; // Maximum text length of 20 characters
		const inputChar = event.key;
		const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
		const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
	
		if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
		  return;
		}
	
		const inputValue = event.target.value;
	
		if (inputValue.length >= maxTextLength) {
		  if (allowedKeys.indexOf(inputChar) === -1) {
			this.NamecharacterLimitReached[fieldName] = true; // Set the validation flag to true to show the warning message
			setTimeout(() => {
			  this.NamecharacterLimitReached[fieldName] = false; // Hide the warning message after 3 seconds
			}, 3000);
			event.preventDefault(); // Prevent entering the exceeded character
		  }
		}
	  }
	
	  isNameLimitReached(fieldName: string): boolean {
		return this.NamecharacterLimitReached[fieldName];
	  }


	  DisallowZero(event: any) {
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
        const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
      
        if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
          // Allow the default behavior for certain keys
          return;
        }
      
        const inputValue = event.target.value;
        const caretStart = event.target.selectionStart;
        const caretEnd = event.target.selectionEnd;
        const modifiedValue = inputValue.slice(0, caretStart) + event.key + inputValue.slice(caretEnd);
        
        if (modifiedValue !== '' && !/^\d*\.?\d*$/.test(modifiedValue)) { 
        //  this.showWarning = false; // Hide the warning message
          event.preventDefault(); // Prevent invalid input
          return;
        }
        const regex = /^\d{0,9}(\.\d{0,2})?$/;
        const maxValue = 999999999;
        if (!regex.test(modifiedValue) || parseFloat(modifiedValue) > maxValue) {
          if (parseFloat(modifiedValue) > maxValue) {
            this.showWarning = true;
            setTimeout(() => {
              this.showWarning = false;
            }, 3000);
            event.preventDefault();
          } else{
			this.showWarning = false;
		  }
          event.preventDefault();
        } 
      }

		//setAmountValue
		setAmountValueForBankAuth(amount: string){
			if(amount) {
				this.plan.amount = parseFloat(amount).toFixed(2);
			}      
		}

		goBack(){
			this.Location.back();
		 }

        // disallow 0
		 validateNumberInput(event: any) {
			const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter'];
			const allowedKeyCodes = [46, 8, 9, 27, 13, 37, 39]; // Backspace, Delete, Tab, Escape, Enter
		  
			if (allowedKeys.indexOf(event.key) !== -1 || allowedKeyCodes.indexOf(event.keyCode) !== -1) {
			  // Allow the default behavior for certain keys
			  return;
			}
		  
			if (!/^\d+$/.test(event.key)) {
			  // Prevent input if it's not a digit
			  event.preventDefault();
			}
		}

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/plan/createplan.component.ts